// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  src:
    local("Open Sans"),
    local("OpenSans"),
    url(https://fonts.gstatic.com/s/opensans/v13/cJZKeOuBrn4kERxqtaUH3T8E0i7KZn-EPnyo3HZu7kw.woff) format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  src:
    local("Open Sans Semibold"),
    local("OpenSans-Semibold"),
    url(https://fonts.gstatic.com/s/opensans/v13/MTP_ySUJH_bn48VBG8sNSnhCUOGz7vYGh680lGh-uXM.woff) format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  src:
    local("Open Sans Light"),
    local("OpenSans-Light"),
    url(https://fonts.gstatic.com/s/opensans/v13/DXI1ORHCpsQm3Vp6mXoaTXhCUOGz7vYGh680lGh-uXM.woff) format("woff");
}

@font-face {
  font-family: "Orelega One";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/orelegaone/v13/3qTpojOggD2XtAdFb-QXZFt93kY6ah7E.woff2) format("woff2");
  unicode-range:
    U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193,
    U+2212, U+2215, U+FEFF, U+FFFD;
}

body {
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  padding: 0;
  margin: 0;
}

[class*="Chip__ChipLabel"][class*="TextBase"] {
  color: #222 !important;
  font-size: 13px;
  font-weight: 600;
}

&:not([class*="Chip__ChipLabel"])[class*="Chip"] {
  background-color: #ece4ff;
}

#panel-populationOverview,
#panel-listsOverlap {
  height: calc(100% - 50px);
  padding-top: 0;
}

[class*="OverlaySurface__OverlaySurfaceContentArea"] {
  border-radius: 10px !important;
}

[class*="Portal__InvisiBox"] {
  z-index: 1300 !important;
}

aside {
  overflow: visible !important;
}
`, "",{"version":3,"sources":["webpack://./src/style.global.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB;;;iHAG+G;AACjH;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB;;;iHAG+G;AACjH;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB;;;iHAG+G;AACjH;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,2GAA2G;EAC3G;;;kCAGgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src:\n    local(\"Open Sans\"),\n    local(\"OpenSans\"),\n    url(https://fonts.gstatic.com/s/opensans/v13/cJZKeOuBrn4kERxqtaUH3T8E0i7KZn-EPnyo3HZu7kw.woff) format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src:\n    local(\"Open Sans Semibold\"),\n    local(\"OpenSans-Semibold\"),\n    url(https://fonts.gstatic.com/s/opensans/v13/MTP_ySUJH_bn48VBG8sNSnhCUOGz7vYGh680lGh-uXM.woff) format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 300;\n  src:\n    local(\"Open Sans Light\"),\n    local(\"OpenSans-Light\"),\n    url(https://fonts.gstatic.com/s/opensans/v13/DXI1ORHCpsQm3Vp6mXoaTXhCUOGz7vYGh680lGh-uXM.woff) format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Orelega One\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/orelegaone/v13/3qTpojOggD2XtAdFb-QXZFt93kY6ah7E.woff2) format(\"woff2\");\n  unicode-range:\n    U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\n    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193,\n    U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\nbody {\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  padding: 0;\n  margin: 0;\n}\n\n[class*=\"Chip__ChipLabel\"][class*=\"TextBase\"] {\n  color: #222 !important;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n&:not([class*=\"Chip__ChipLabel\"])[class*=\"Chip\"] {\n  background-color: #ece4ff;\n}\n\n#panel-populationOverview,\n#panel-listsOverlap {\n  height: calc(100% - 50px);\n  padding-top: 0;\n}\n\n[class*=\"OverlaySurface__OverlaySurfaceContentArea\"] {\n  border-radius: 10px !important;\n}\n\n[class*=\"Portal__InvisiBox\"] {\n  z-index: 1300 !important;\n}\n\naside {\n  overflow: visible !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
